import { RootState } from '@/store/Reducer'

export const selectBreakManagement = (state: RootState) => state.breakManagement
